import {
  CONVERSATION_FACTS_DIMENSIONS,
  DRIFT_CHAT_OPPORTUNITY_EVENTS,
  DRIFT_CHAT_OPPORTUNITY_OVERVIEW,
  PLAYBOOKS_CHAT_DIMENSIONS,
} from 'cube'

import { CubeQuery } from '@driftt/dds.reports'

/**
 * Base cube query for the opportunitites table
 */
export const OpportunitiesBaseQuery: CubeQuery = {
  name: 'OpportunitiesBaseQuery',
  query: {
    dimensions: [
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_ID,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_DOMAIN,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.COMPANY_NAME,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_NAME,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_AMOUNT,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_TYPE,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_STAGE,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.IS_SOURCED,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.IS_INFLUENCED,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_CREATED_AT_WITH_ZONE,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_CLOSED_AT_WITH_ZONE,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_CREATED_AT,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_CLOSED_AT,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.DAYS_IN_CYCLE,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.CONVERSATION_COUNT,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.FIRST_CONVERSATION_CREATED_AT,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.DISPLAY_NAME,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.LAST_CONVERSATION_ROUTING_OUTCOME,
      DRIFT_CHAT_OPPORTUNITY_OVERVIEW.LAST_MEETING_BOOKED_BY_AGENT_DISPLAY_NAME,
    ],
    order: [[DRIFT_CHAT_OPPORTUNITY_OVERVIEW.OPPORTUNITY_AMOUNT, 'desc']],
  },
  queryName: 'OpportunitiesBaseQuery',
}

/**
 * Base Cube query for getting the total count of opportunities
 */
export const OpportunityCountBaseQuery: CubeQuery = {
  name: 'OpportunityCount',
  queryName: 'OpportunityCount',
  query: {
    measures: [DRIFT_CHAT_OPPORTUNITY_OVERVIEW.COUNT],
  },
}

/**
 * Base Cube query for getting the sum of the opportunity amount in all opportunities
 */
export const OpportunitiesAmountSumQuery: CubeQuery = {
  name: 'OpportunitiesAmountSumQuery',
  query: {
    measures: [DRIFT_CHAT_OPPORTUNITY_OVERVIEW.SUM_AMOUNT],
    dimensions: [],
  },
  queryName: 'OpportunitiesAmountSumQuery',
}

/**
 * Base query for the opportunity timeline
 */
export const OpportunityTimelineBaseQuery: CubeQuery = {
  name: 'OpportunityTimelineBaseQuery',
  queryName: 'OpportunityTimelineBaseQuery',
  query: {
    dimensions: [
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_ID, // QUESTION: will this join cause issue?
      DRIFT_CHAT_OPPORTUNITY_EVENTS.OPPORTUNITY_ID,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.EVENT_TYPE,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.EVENT_DATE_AT,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.EVENT_DATE_AT_WITH_ZONE,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.OPPORTUNITY_DOMAIN,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.OPPORTUNITY_TYPE,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.OPPORTUNITY_CREATED_AT,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.OPPORTUNITY_CREATED_AT_WITH_ZONE,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.END_USER_EMAIL,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.END_USER_DISPLAY_NAME,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.AGENT_NAME,
      DRIFT_CHAT_OPPORTUNITY_EVENTS.LEAD_CAPTURE_SOURCE, // QUESTION: will this cause issue?
      CONVERSATION_FACTS_DIMENSIONS.PLAYBOOK_ID,
      PLAYBOOKS_CHAT_DIMENSIONS.PLAYBOOK_NAME,
    ],
    order: {
      [DRIFT_CHAT_OPPORTUNITY_EVENTS.EVENT_DATE_AT]: 'desc',
    },
  },
}
